import {
  NavigationEventType,
  NavigationEventDirection
} from "../elements/CarouselControls.js";
import { Events as ScrollEvents } from "./scroll-handler.js";
import { CarouselFeature } from "./feature-base.js";
class PagingControlsFeature extends CarouselFeature {
  constructor() {
    super(...arguments);
    this.onScrollPagingCallback = ({
      scrollLeft,
      clientWidth,
      scrollWidth
    }) => {
      this.micro(() => {
        const isAtStart = Math.abs(scrollLeft) <= 0;
        const isAtEnd = Math.round(Math.abs(scrollLeft) + clientWidth) >= scrollWidth - 1;
        this.host.controls.prev = !isAtStart;
        this.host.controls.next = !isAtEnd;
      }, "update control buttons visibility");
    };
    this.handlePageRequest = (ev) => {
      const {
        controls,
        scrollToSlide,
        assignedChildren,
        features: { slideVisibility, scroller, writingDirection }
      } = this.host;
      scroller.scroller.inertia = 0;
      slideVisibility.updateVisibleSlides(this.host.scrollLeft);
      if (ev.navigationType === NavigationEventDirection.NEXT) {
        const nextNotFullyVisibleSlideIndex = slideVisibility.slidesVisibilityRatio.findIndex(
          (e, i, arr) => arr[i - 1] > e
        );
        if (nextNotFullyVisibleSlideIndex > -1) {
          const nextSlide = assignedChildren[nextNotFullyVisibleSlideIndex];
          const isLastSlide = nextNotFullyVisibleSlideIndex === assignedChildren.length - 1;
          scrollToSlide(
            nextSlide,
            writingDirection.isRTL ? 1 : 0,
            isLastSlide ? 0 : controls.controllerWidth
          );
        }
      } else {
        const maxVisibility = Math.max(...slideVisibility.slidesVisibilityRatio);
        const nextNotFullyVisibleSlideIndex = slideVisibility.slidesVisibilityRatio.findIndex(
          (e, i, arr) => arr[i + 1] === maxVisibility
        );
        if (nextNotFullyVisibleSlideIndex > -1) {
          const nextSlide = assignedChildren[nextNotFullyVisibleSlideIndex];
          scrollToSlide(
            nextSlide,
            writingDirection.isRTL ? 0 : 1,
            controls.controllerWidth
          );
        }
      }
    };
  }
  connectedCallback() {
    this.host.features.scroller.addEventListener(
      ScrollEvents.UPDATE,
      this.onScrollPagingCallback
    );
    this.host.addEventListener(
      NavigationEventType,
      this.handlePageRequest
    );
  }
  disconnectedCallback() {
    this.host.features.scroller.removeEventListener(
      ScrollEvents.UPDATE,
      this.onScrollPagingCallback
    );
    this.host.removeEventListener(
      NavigationEventType,
      this.handlePageRequest
    );
  }
}
export {
  PagingControlsFeature
};
